import { Component, ViewEncapsulation } from '@angular/core';
import { CardPickerComponent } from '../../cards/card-picker/card-picker.component';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Gtag } from 'angular-gtag';

@Component({
    selector: 'app-landing-toolbar',
    templateUrl: './landing-toolbar.component.html',
    styleUrls: ['./landing-toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class LandingToolbarComponent {

    public constructor(private readonly router: Router,
                       private readonly gtag: Gtag,
                       private readonly dialog: MatDialog) {
    }

    public goToHome() {
        this.router.navigate(['/']);
    }

    public openCardSearch() {
        this.gtag.event('card_search_from_landing', {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            event_category: 'search'
        });
        this.dialog.open(CardPickerComponent, {
            width: '100vw',
            maxWidth: '100vw',
            height: `calc(100vh - 10%)`,
            disableClose: false,
        });
    }

}
